import { Fit } from "@seneca/image-service-client";

import { ModuleDeviceRequirements } from "features/module/types";

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 300,
  desktopOnly: false
};

export enum SimpleCalculationMode {
  regular = "regular",
  scaffolded = "scaffolded"
}

export const assetParameters = {
  default: {
    width: 500,
    height: 500,
    fit: Fit.INSIDE
  }
};
